import { BubbleMetric } from '../../../components/BubbleMetric';
import { useUser } from '../../../contexts/UserContext';
import clsx from 'clsx';
import { useOperator } from '../../../contexts/OperatorContext';

interface Props {
  ticketData: any[];
  loading: boolean;
  selectedMetric: string;
  setSelectedMetric(metric: any): void;
}

export const TicketMetrics = ({
  ticketData,
  loading,
  selectedMetric,
  setSelectedMetric,
}: Props) => {
  const operator = useOperator();
  const user = useUser();
  const hasCreate =
    (operator.type === 'Hospitality' && user.permissions.canHosSupportCreate) ||
    (operator.type === 'Residential' && user.permissions.canResSupportCreate);

  return (
    <div
      className={clsx(
        'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 w-full p-6',
        {
          'col-span-full justify-items-center': !hasCreate,
          'col-span-5 justify-items-start ': hasCreate,
        }
      )}
    >
      <BubbleMetric
        total={
          ticketData.filter(
            (ticket) => ticket.behavior.toLowerCase() !== 'closed'
          ).length
        }
        backgroundColor="#A3C7CF"
        color="#0A4C5B"
        label="Open Tickets"
        loading={loading}
        onSelect={setSelectedMetric}
        selectedValue={selectedMetric}
        value="open"
      />
      <BubbleMetric
        total={
          ticketData.filter(
            (ticket) => ticket.categoryName.toLowerCase() == 'incident'
          ).length
        }
        label="Incidents"
        backgroundColor="#EABEC0"
        color="#9E1921"
        loading={loading}
        onSelect={setSelectedMetric}
        selectedValue={selectedMetric}
        value="incident"
      />
      <BubbleMetric
        total={
          ticketData.filter(
            (ticket) =>
              ticket.categoryName.toLowerCase() == 'question' ||
              ticket.categoryName.toLowerCase() == 'request'
          ).length
        }
        label="Question / Request"
        backgroundColor="#BDDDD5"
        color="#074F3E"
        loading={loading}
        onSelect={setSelectedMetric}
        selectedValue={selectedMetric}
        value="question/request"
      />
      <BubbleMetric
        total={
          ticketData.filter(
            (ticket) =>
              ticket.categoryName.toLowerCase() !== 'question' &&
              ticket.categoryName.toLowerCase() !== 'request' &&
              ticket.categoryName.toLowerCase() !== 'incident'
          ).length
        }
        label="Other"
        backgroundColor="#D2B7D8"
        color="#681A78"
        loading={loading}
        onSelect={setSelectedMetric}
        selectedValue={selectedMetric}
        value="other"
      />
    </div>
  );
};
